import axios from "./index";
import { OTHER_CEMAIL_TYPE, INVALID_CEMAIL_KEYWORD, ERROR1 } from "../constants";
const CEMAIL = "/profile/user/cemail"; //TODO Move to constants

export const getCEmails = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: CEMAIL
        });
        return data;
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage || ERROR1;
        return {
            data: [],
            succeed: false,
            message: errMsg
        };
    }
};

export const addCEmail = async ({ statusType, emailAddress }) => {
    try {
        await axios({
            method: "POST",
            url: CEMAIL,
            data: {
                statusType,
                emailAddr: emailAddress
            }
        });
        return { succeed: true, message: "Successfully added." };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        if (errMsg.includes(INVALID_CEMAIL_KEYWORD)) {
            errMsg = "Invalid Email.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};

export const updateCEmail = async ({
    oldStatusType,
    oldEmailAddress,
    statusType,
    emailAddress
}) => {
    try {
        await axios({
            method: "PUT",
            url: CEMAIL,
            params: {
                oldStatusType,
                oldEmailAddr: oldEmailAddress
            },
            data: {
                statusType,
                emailAddr: emailAddress
            }
        });
        return { succeed: true, message: "Successfully updated." };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        if (errMsg.includes(INVALID_CEMAIL_KEYWORD)) {
            errMsg = "Invalid Email.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};

export const deleteCEmail = async ({ emailAddress }) => {
    try {
        await axios({
            method: "DELETE",
            url: CEMAIL,
            params: {
                statusType: OTHER_CEMAIL_TYPE,
                emailAddress
            }
        });
        return { succeed: true, message: "Successfully deleted." };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg
        };
    }
};

export const makePrimary = async ({ emailAddress }) => {
    try {
        await axios({
            method: "PUT",
            url: "/profile/user/cemail/makeprimary",
            data: {
                statusType: OTHER_CEMAIL_TYPE,
                emailAddr: emailAddress
            }
        });
        return { succeed: true, message: "Successfully updated." };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg
        };
    }
};